<div class="order__container" style="margin-top: 10px;margin-bottom: 10px;">
  <mat-card appearance="outlined" class="order__card">
    <div class="order__card--inner-container">
      <div class="order__card--text-container">
        <h2 [class]="isSuccessful ? 'order__card--success-heading' : 'order__card--failed-heading'">
          <ng-content select="[order-heading]"></ng-content>
        </h2>
        <p [class]="isSuccessful ? 'order__card--success-text' : 'order__card--failed-text'">
          <ng-content select="[order-content]"></ng-content>
        </p>
      </div>
<!--      <div class="order&#45;&#45;border"></div>-->
      <div class="order__card--text-container order__card--text-color">
        <p class="order__card--paragraph">
          <ng-content select="[thanks-content]"></ng-content>
        </p>
        <h2 class="order__card--paragraph order__card--paragraph__heading">
          <ng-content select="[thanks-heading]"></ng-content>
        </h2>
      </div>
    </div>
    <mat-card-footer class="order--footer">
      <button mat-raised-button [routerLink]="['/']" color="primary" gaEvent="order_callback_back_to_site" gaCategory="buttons_tracking">
        <mat-icon>arrow_backward_ios</mat-icon>
        <span>Înapoi în site</span>
      </button>
    </mat-card-footer>
  </mat-card>
</div>
